import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import * as Constant from '../Constant'; // Pastikan konstanta diimpor dengan benar
import axios from 'axios';
import Cookies from 'universal-cookie';
import Header from '../Components/Header';
import ClipLoader from "react-spinners/ClipLoader";
import { css } from '@emotion/core';
import './rekapsantri.css';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: #ea6123 solid 4px;
`;

const cookies = new Cookies();

class RekapSantri extends Component {
    constructor() {
        super();
        this.state = {
            santriList: [], // Inisialisasi dengan array kosong
            accessToken: cookies.get('accessToken'),
            loading: true, // Add loading state
            totalTagihan: 0,
            sudahTerbayar: 0,
            periode: [],
        };
    }

    componentDidMount() {
        this.getSantriData();
    }

    getSantriData() {
        const { accessToken } = this.state;

        if (accessToken) {
            axios
                .get(Constant.GET_SANTRI, {
                    headers: {
                        Authorization: accessToken, // Kirimkan token sebagai header
                    },
                })
                .then((response) => {
                    console.log('Data API:', response.data); // Debug data API

                    // Memeriksa apakah respons data adalah objek dengan properti yang benar
                    if (response.data.santri && Array.isArray(response.data.santri)) {
                        this.setState({
                            santriList: response.data.santri, // Ambil array data santri
                            totalTagihan: response.data.total_tagihan, // Set total tagihan
                            sudahTerbayar: response.data.sudah_terbayar, // Set sudah terbayar
                            periode: response.data.periode,
                            loading: false,

                        });
                    } else {
                        console.error('Format data tidak sesuai:', response.data);
                        this.setState({
                            santriList: [], 
                            totalTagihan: 0,
                            sudahTerbayar: 0,
                            periode: [],
                            loading: false,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error fetching santri data:', error);
                    this.setState({
                        santriList: [], 
                        totalTagihan: 0,
                        sudahTerbayar: 0,
                        periode: [],
                        loading: false, 
                    });
                });
        } else {
            console.error('Access token tidak tersedia');
            this.setState({ loading: false }); 
        }
    }
    // Fungsi untuk memformat angka menjadi format uang rupiah tanpa desimal
    formatRupiah = (nominal) => {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(nominal);
    };

    render() {
        const { santriList, go_home, totalTagihan, sudahTerbayar, periode, loading } = this.state;
        if (go_home) {
            return <Redirect exact to='/home' />;
        }

        return (
            <div className="rekap-container">
                <header id="header">
                    <Header />
                    <nav className="left header-kembali">
                        <i
                            id="ic-sidebar"
                            className="fa fa-arrow-left"
                            onClick={() => this.setState({ go_home: true })}
                            style={{
                                margin: '10px',
                            }}
                        ></i>
                        Rekap Santri
                    </nav>
                </header>
                {loading ? (
                    <div className="loading-container">
                        <ClipLoader css={override} size={150} color={"#ea6123"} loading={loading} />
                    </div>
                ) : (
                    <div className="rekap-cards-container">
                        {santriList.length > 0 ? (
                            santriList.map((santri) => {
                                const tagihan = santri.total_tagihan || 0;
                                const terbayar = santri.sudah_terbayar || 0;
                                const progress = tagihan > 0 ? parseFloat(((terbayar / tagihan) * 100).toFixed(2)) : 0;
                                const tahun_ajaran = santri.periode.length > 0 ? santri.periode[0].split('/')[0] : null;
                                const tunggakan = tagihan - terbayar;

                                return (
                                    <Link key={santri.id} to={`/santri/${santri.id}`} className="rekap-card-link">
                                        <div className="rekap-card">
                                            <div className="foto-container-rekap">
                                                <img src={santri.foto || '/profile-default.png'} alt="Foto Santri" className="foto-rekap" />
                                            </div>
                                            <div className="santri-info">
                                                <h2>{santri.full_name}</h2>
                                                <div className="progress-bar-container">
                                                    <div className="progress-bar-background">
                                                        <div className="progress-bar" style={{ width: `${progress}%` }}></div>
                                                    </div>
                                                    <p className="progress-text">
                                                        {this.formatRupiah(terbayar)} / {this.formatRupiah(tagihan)} ({(progress)}%)
                                                    </p>
                                                </div>
                                                <div className="rekap-footer">
                                                    <p>Periode: <br />{tahun_ajaran || 'Tidak tersedia'} - Sekarang</p>
                                                    <p>Tunggakan: <br /> {this.formatRupiah(tunggakan)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })
                        ) : (
                            <div className="no-data">
                                <p className="no-data-text">Tidak ada data santri untuk ditampilkan</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }


}

export default RekapSantri;
